var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPhone)?_c('PhoneView'):_c('PCView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }